import { lazy } from 'react'
import withSuspense from '../../shared/hoc/withSuspense'

const RootRouter = lazy(() => import('./RootRouter'))

export default withSuspense(RootRouter, { progress: 75 })
